/**
 * All user-facing copy for the marketing site + onboarding wizard, one file
 * per language under ./locales/.
 *
 * Norwegian (nb) is the platform default and the source of truth for the key
 * set. Missing keys fall back per language → English → Norwegian, so a
 * partially translated dictionary never renders blank strings. Values may be
 * strings, arrays or objects; components map over arrays directly. Strings
 * support {var} interpolation via t(key, vars).
 *
 * The legal pages (privacy/terms) are deliberately NOT translated:
 * machine-translating legal text creates obligations nobody reviewed. They
 * render in Norwegian in every language until reviewed translations exist.
 *
 * To add a language: create ./locales/<code>.js with the full key set, import
 * it here, and add it to `translations` and `LANGUAGES`. Everything else
 * (picker, persistence, browser detection, date locales) picks it up.
 */

import nb from './locales/nb'
import en from './locales/en'
import sv from './locales/sv'
import da from './locales/da'
import fi from './locales/fi'
import is_ from './locales/is'
import fo from './locales/fo'

export const translations = { nb, en, sv, da, fi, is: is_, fo }

/** Display metadata for the language picker, in menu order. */
export const LANGUAGES = [
  { code: 'nb', label: 'Norsk', flag: '🇳🇴' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'sv', label: 'Svenska', flag: '🇸🇪' },
  { code: 'da', label: 'Dansk', flag: '🇩🇰' },
  { code: 'fi', label: 'Suomi', flag: '🇫🇮' },
  { code: 'is', label: 'Íslenska', flag: '🇮🇸' },
  { code: 'fo', label: 'Føroyskt', flag: '🇫🇴' },
]

/** BCP 47 locale per language, for date/number formatting. */
export const LOCALES = {
  nb: 'nb-NO',
  en: 'en-US',
  sv: 'sv-SE',
  da: 'da-DK',
  fi: 'fi-FI',
  is: 'is-IS',
  fo: 'fo-FO',
}
